module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst renderMode = (storage.request || {}).renderMode || ''\nlet signedAt = ''\nif(model.signedAt){\nconst m = utils.moment(model.signedAt);\nsignedAt = `am ${m.format('DD.MM.YYYY')} um ${m.format('HH:mm')} Uhr`\n}\n%>\n<div>\n<section class=\"main\">\n<div class=\"background\"></div>\n<% if(!model.signature && renderMode !== 'html'){ %>\n<div class=\"controls\">\n<button class=\"enlarge\">\n<i class=\"fi fi-document-enlarge enlarge\"></i>\n<i class=\"fi fi-document-shrink shrink\"></i>\n</button>\n<button class=\"reset\"><i class=\"fi fi-document-reset\"></i></button>\n<button class=\"save\"><i class=\"fi fi-save\"></i></button>\n</div>\n<% } %>\n<div class=\"sign\">\n<%\nif(model.signature){\n%><img alt=\"signature\" title=\"Unterschrift\" src=\"<%- model.signature %>\"/><%\n} else {\n%><canvas></canvas><%\n}\n%>\n</div>\n<div class=\"subTitle\"><%= model.subTitle %><br><span class=\"signedAt\"><%= signedAt %></span></div>\n</section>\n<%- helpers.renderSection('right') %>\n</div>"
  , __filename = "components/templates/core/documents/sign/sign.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const renderMode = (storage.request || {}).renderMode || ''
let signedAt = ''
if(model.signedAt){
const m = utils.moment(model.signedAt);
signedAt = `am ${m.format('DD.MM.YYYY')} um ${m.format('HH:mm')} Uhr`
}

    ; __line = 8
    ; __append("\n<div>\n<section class=\"main\">\n<div class=\"background\"></div>\n")
    ; __line = 12
    ;  if(!model.signature && renderMode !== 'html'){ 
    ; __append("\n<div class=\"controls\">\n<button class=\"enlarge\">\n<i class=\"fi fi-document-enlarge enlarge\"></i>\n<i class=\"fi fi-document-shrink shrink\"></i>\n</button>\n<button class=\"reset\"><i class=\"fi fi-document-reset\"></i></button>\n<button class=\"save\"><i class=\"fi fi-save\"></i></button>\n</div>\n")
    ; __line = 21
    ;  } 
    ; __append("\n<div class=\"sign\">\n")
    ; __line = 23
    ; 
if(model.signature){

    ; __line = 25
    ; __append("<img alt=\"signature\" title=\"Unterschrift\" src=\"")
    ; __append( model.signature )
    ; __append("\"/>")
    ; 
} else {

    ; __line = 27
    ; __append("<canvas></canvas>")
    ; 
}

    ; __line = 29
    ; __append("\n</div>\n<div class=\"subTitle\">")
    ; __line = 31
    ; __append(escapeFn( model.subTitle ))
    ; __append("<br><span class=\"signedAt\">")
    ; __append(escapeFn( signedAt ))
    ; __append("</span></div>\n</section>\n")
    ; __line = 33
    ; __append( helpers.renderSection('right') )
    ; __append("\n</div>")
    ; __line = 34
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/sign/sign.ejs

}